
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.17.0
 * Query Engine version: 393aa359c9ad4a4bb28630fb5613f9c281cde053
 */
Prisma.prismaVersion = {
  client: "5.17.0",
  engine: "393aa359c9ad4a4bb28630fb5613f9c281cde053"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.NodesScalarFieldEnum = {
  id: 'id',
  expiry: 'expiry'
};

exports.Prisma.OutboxScalarFieldEnum = {
  sequence_id: 'sequence_id',
  mutation_id: 'mutation_id',
  channel: 'channel',
  name: 'name',
  rejected: 'rejected',
  data: 'data',
  headers: 'headers',
  locked_by: 'locked_by',
  lock_expiry: 'lock_expiry',
  processed: 'processed'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  role: 'role',
  password: 'password',
  signature: 'signature',
  emailNamePart: 'emailNamePart',
  resetToken: 'resetToken',
  resetTokenExpires: 'resetTokenExpires',
  siteId: 'siteId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SiteScalarFieldEnum = {
  id: 'id',
  name: 'name',
  url: 'url',
  goal: 'goal',
  type: 'type',
  icpModelId: 'icpModelId',
  icpModelSampleSize: 'icpModelSampleSize',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  gotDemoTraffic: 'gotDemoTraffic',
  hasBotTraffic: 'hasBotTraffic',
  botTrafficDetails: 'botTrafficDetails'
};

exports.Prisma.EmailDomainScalarFieldEnum = {
  id: 'id',
  domain: 'domain',
  siteId: 'siteId',
  isPublic: 'isPublic',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isEnabled: 'isEnabled',
  isAWSManaged: 'isAWSManaged',
  dnsConfigured: 'dnsConfigured',
  mailserver: 'mailserver'
};

exports.Prisma.MailboxScalarFieldEnum = {
  id: 'id',
  siteId: 'siteId',
  emailDomainid: 'emailDomainid',
  emailAddress: 'emailAddress',
  firstName: 'firstName',
  lastName: 'lastName',
  password: 'password',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.InvitationScalarFieldEnum = {
  id: 'id',
  email: 'email',
  token: 'token',
  siteId: 'siteId',
  role: 'role',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refreshToken: 'refreshToken',
  accessToken: 'accessToken',
  expiresAt: 'expiresAt',
  idToken: 'idToken',
  scope: 'scope',
  sessionState: 'sessionState',
  tokenType: 'tokenType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  siteId: 'siteId',
  expires: 'expires',
  sessionToken: 'sessionToken'
};

exports.Prisma.CSVUploadScalarFieldEnum = {
  id: 'id',
  siteId: 'siteId',
  file: 'file',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  requirePayment: 'requirePayment',
  emailsProgress: 'emailsProgress',
  emailsTotal: 'emailsTotal',
  bounceCount: 'bounceCount',
  paymentId: 'paymentId'
};

exports.Prisma.AIUploadScalarFieldEnum = {
  id: 'id',
  siteId: 'siteId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  requirePayment: 'requirePayment',
  prompt: 'prompt',
  rolePrompt: 'rolePrompt',
  campaignId: 'campaignId',
  paymentId: 'paymentId',
  status: 'status',
  domains: 'domains',
  domainsInvited: 'domainsInvited',
  companies: 'companies',
  companiesInvited: 'companiesInvited',
  senderName: 'senderName',
  senderEmail: 'senderEmail',
  senderSignature: 'senderSignature',
  emailDomainid: 'emailDomainid'
};

exports.Prisma.AIEmailCampaignScalarFieldEnum = {
  id: 'id',
  name: 'name',
  sendTime: 'sendTime',
  emailsPerDay: 'emailsPerDay',
  invitesPerDay: 'invitesPerDay',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  siteId: 'siteId',
  prompt: 'prompt',
  rolePrompt: 'rolePrompt',
  writingPrompt: 'writingPrompt',
  status: 'status',
  scheduleId: 'scheduleId',
  domains: 'domains',
  weights: 'weights',
  previousWeights: 'previousWeights',
  domainsInvited: 'domainsInvited',
  weightsInvited: 'weightsInvited',
  previousWeightsInvited: 'previousWeightsInvited',
  daysSent: 'daysSent',
  strategyId: 'strategyId',
  relevance: 'relevance',
  reason: 'reason',
  examples: 'examples',
  company_count: 'company_count'
};

exports.Prisma.AIStrategyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  siteId: 'siteId',
  status: 'status',
  scheduleId: 'scheduleId',
  prompt: 'prompt',
  whyPrompt: 'whyPrompt',
  isRunning: 'isRunning',
  sendTime: 'sendTime',
  emailsPerDay: 'emailsPerDay',
  invitesPerDay: 'invitesPerDay',
  daysSent: 'daysSent'
};

exports.Prisma.CompanyLeadExclusionScalarFieldEnum = {
  id: 'id',
  domain: 'domain',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentScalarFieldEnum = {
  id: 'id',
  siteId: 'siteId',
  amount: 'amount',
  currency: 'currency',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  uploadId: 'uploadId',
  paypalObject: 'paypalObject'
};

exports.Prisma.AIEmailScalarFieldEnum = {
  id: 'id',
  siteId: 'siteId',
  uploadId: 'uploadId',
  email: 'email',
  subject: 'subject',
  body: 'body',
  name: 'name',
  signature: 'signature',
  subdomain: 'subdomain',
  prompt: 'prompt',
  summary: 'summary',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  emailDomainid: 'emailDomainid',
  aiUploadId: 'aiUploadId',
  company_title: 'company_title',
  company_description: 'company_description',
  company_extra_description: 'company_extra_description',
  company_relevance: 'company_relevance',
  role_relevance: 'role_relevance',
  title: 'title',
  discard_reason: 'discard_reason',
  bodyEdits: 'bodyEdits',
  subjectEdits: 'subjectEdits',
  queueBucket: 'queueBucket',
  campaignName: 'campaignName',
  emailNamePart: 'emailNamePart',
  configCampaignId: 'configCampaignId',
  configCampaignName: 'configCampaignName',
  plainTextOnly: 'plainTextOnly',
  is_replied: 'is_replied',
  is_call: 'is_call',
  sequenceStatus: 'sequenceStatus',
  usedDomain: 'usedDomain'
};

exports.Prisma.AIEmailAttachmentScalarFieldEnum = {
  id: 'id',
  aiEmailId: 'aiEmailId',
  base64Data: 'base64Data',
  name: 'name',
  type: 'type',
  disposition: 'disposition',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.InboxEmailScalarFieldEnum = {
  id: 'id',
  fromEmail: 'fromEmail',
  fromName: 'fromName',
  emailRecipients: 'emailRecipients',
  subject: 'subject',
  textContent: 'textContent',
  isAutomatedEmail: 'isAutomatedEmail',
  type: 'type',
  imapId: 'imapId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmailBounceScalarFieldEnum = {
  id: 'id',
  bouncedEmail: 'bouncedEmail',
  bounceType: 'bounceType',
  bounceReason: 'bounceReason',
  statusCode: 'statusCode',
  diagnosticCode: 'diagnosticCode',
  reportingMta: 'reportingMta',
  receivedFromMta: 'receivedFromMta',
  finalRecipient: 'finalRecipient',
  action: 'action',
  emailId: 'emailId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AILinkedInInviteScalarFieldEnum = {
  id: 'id',
  siteId: 'siteId',
  email: 'email',
  linkedinUrl: 'linkedinUrl',
  uploadId: 'uploadId',
  subject: 'subject',
  body: 'body',
  signature: 'signature',
  prompt: 'prompt',
  summary: 'summary',
  name: 'name',
  sender: 'sender',
  connection_message: 'connection_message',
  conversation_id: 'conversation_id',
  recent_messages: 'recent_messages',
  lead: 'lead',
  correlation_id: 'correlation_id',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  aiUploadId: 'aiUploadId',
  company_title: 'company_title',
  company_description: 'company_description',
  company_extra_description: 'company_extra_description',
  company_relevance: 'company_relevance',
  role_relevance: 'role_relevance',
  discard_reason: 'discard_reason',
  bodyEdits: 'bodyEdits',
  subjectEdits: 'subjectEdits'
};

exports.Prisma.AILinkedInInviteStatScalarFieldEnum = {
  id: 'id',
  inviteId: 'inviteId',
  status: 'status',
  siteId: 'siteId',
  uploadId: 'uploadId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  campaignName: 'campaignName',
  detail: 'detail',
  aiUploadId: 'aiUploadId'
};

exports.Prisma.EmailScalarFieldEnum = {
  id: 'id',
  email: 'email',
  aiUploadId: 'aiUploadId',
  siteId: 'siteId',
  apollo_id: 'apollo_id',
  first_name: 'first_name',
  last_name: 'last_name',
  name: 'name',
  linkedin_url: 'linkedin_url',
  title: 'title',
  email_status: 'email_status',
  photo_url: 'photo_url',
  twitter_url: 'twitter_url',
  github_url: 'github_url',
  facebook_url: 'facebook_url',
  extrapolated_email_confidence: 'extrapolated_email_confidence',
  headline: 'headline',
  organization_id: 'organization_id',
  employment_history: 'employment_history',
  state: 'state',
  city: 'city',
  country: 'country',
  organization: 'organization',
  is_likely_to_engage: 'is_likely_to_engage',
  departments: 'departments',
  subdepartments: 'subdepartments',
  seniority: 'seniority',
  functions: 'functions',
  phone_numbers: 'phone_numbers',
  intent_strength: 'intent_strength',
  show_intent: 'show_intent',
  revealed_for_current_team: 'revealed_for_current_team',
  createdAt: 'createdAt',
  best_match: 'best_match',
  summary: 'summary',
  company_title: 'company_title',
  company_description: 'company_description',
  company_extra_description: 'company_extra_description',
  company_relevance: 'company_relevance',
  role_relevance: 'role_relevance'
};

exports.Prisma.InviteAccountScalarFieldEnum = {
  id: 'id',
  email: 'email',
  aiUploadId: 'aiUploadId',
  apollo_id: 'apollo_id',
  first_name: 'first_name',
  last_name: 'last_name',
  name: 'name',
  linkedin_url: 'linkedin_url',
  title: 'title',
  email_status: 'email_status',
  photo_url: 'photo_url',
  twitter_url: 'twitter_url',
  github_url: 'github_url',
  facebook_url: 'facebook_url',
  extrapolated_email_confidence: 'extrapolated_email_confidence',
  headline: 'headline',
  organization_id: 'organization_id',
  employment_history: 'employment_history',
  state: 'state',
  city: 'city',
  country: 'country',
  organization: 'organization',
  is_likely_to_engage: 'is_likely_to_engage',
  departments: 'departments',
  subdepartments: 'subdepartments',
  seniority: 'seniority',
  functions: 'functions',
  phone_numbers: 'phone_numbers',
  intent_strength: 'intent_strength',
  show_intent: 'show_intent',
  revealed_for_current_team: 'revealed_for_current_team',
  createdAt: 'createdAt',
  best_match: 'best_match',
  summary: 'summary',
  company_title: 'company_title',
  company_description: 'company_description',
  company_extra_description: 'company_extra_description',
  company_relevance: 'company_relevance',
  role_relevance: 'role_relevance'
};

exports.Prisma.EmailStatScalarFieldEnum = {
  id: 'id',
  emailId: 'emailId',
  status: 'status',
  siteId: 'siteId',
  uploadId: 'uploadId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  campaignName: 'campaignName',
  detail: 'detail',
  aiUploadId: 'aiUploadId',
  vpsIp: 'vpsIp'
};

exports.Prisma.EmailUserSessionScalarFieldEnum = {
  user_pseudo_id: 'user_pseudo_id',
  session_id: 'session_id',
  landing_page: 'landing_page',
  session_start_ts: 'session_start_ts',
  session_end_ts: 'session_end_ts',
  session_length_seconds: 'session_length_seconds',
  browser_info: 'browser_info',
  device_category: 'device_category',
  operating_system: 'operating_system',
  os_version: 'os_version',
  language: 'language',
  limited_ad_tracking: 'limited_ad_tracking',
  city: 'city',
  country: 'country',
  traffic_source: 'traffic_source',
  traffic_medium: 'traffic_medium',
  title: 'title',
  description: 'description',
  mx_record: 'mx_record',
  email: 'email',
  emailId: 'emailId',
  emailDomainid: 'emailDomainid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CrawledSiteScalarFieldEnum = {
  url: 'url',
  uniqueValue: 'uniqueValue',
  deepInfo: 'deepInfo',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt'
};

exports.Prisma.CrawledOrganizationScalarFieldEnum = {
  domain: 'domain',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt',
  description: 'description',
  ga_code: 'ga_code',
  hasFbPixel: 'hasFbPixel',
  hasGoogleTag: 'hasGoogleTag',
  title: 'title',
  founded: 'founded',
  size: 'size',
  country: 'country',
  industry: 'industry',
  name: 'name',
  sales: 'sales',
  subIndustry: 'subIndustry',
  address: 'address',
  city: 'city',
  postalCode: 'postalCode',
  state: 'state',
  employees: 'employees',
  sic: 'sic',
  type: 'type',
  facebook: 'facebook',
  instagram: 'instagram',
  linkedin: 'linkedin',
  snapchat: 'snapchat',
  twitter: 'twitter',
  youtube: 'youtube',
  pinterest: 'pinterest',
  github: 'github',
  tiktok: 'tiktok',
  vimeo: 'vimeo',
  medium: 'medium',
  reddit: 'reddit',
  discord: 'discord',
  slack: 'slack',
  whatsapp: 'whatsapp',
  telegram: 'telegram',
  skype: 'skype',
  zoom: 'zoom',
  clubhouse: 'clubhouse',
  twitch: 'twitch'
};

exports.Prisma.CrawledEmailScalarFieldEnum = {
  value: 'value',
  organizationId: 'organizationId',
  fullName: 'fullName',
  title: 'title',
  level: 'level',
  linkedin: 'linkedin',
  phones: 'phones',
  categories: 'categories',
  gender: 'gender',
  birthDate: 'birthDate',
  inferredSalary: 'inferredSalary',
  facebook: 'facebook',
  twitter: 'twitter',
  github: 'github',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  crawledSource: 'crawledSource',
  verified: 'verified',
  smtpStatus: 'smtpStatus',
  emails: 'emails',
  summary: 'summary',
  bingSummary: 'bingSummary',
  bingResult: 'bingResult',
  bingRichFacts: 'bingRichFacts',
  bingLanguages: 'bingLanguages'
};

exports.Prisma.CrawledExternalEmailScalarFieldEnum = {
  value: 'value',
  organizationId: 'organizationId',
  fullName: 'fullName',
  title: 'title',
  level: 'level',
  linkedin: 'linkedin',
  phones: 'phones',
  categories: 'categories',
  gender: 'gender',
  birthDate: 'birthDate',
  inferredSalary: 'inferredSalary',
  facebook: 'facebook',
  twitter: 'twitter',
  github: 'github',
  verified: 'verified',
  smtpStatus: 'smtpStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  crawledSource: 'crawledSource'
};

exports.Prisma.CrawledPhoneScalarFieldEnum = {
  value: 'value',
  organizationId: 'organizationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  crawledSource: 'crawledSource'
};

exports.Prisma.CrawledBingSessionScalarFieldEnum = {
  id: 'id',
  domains: 'domains',
  messages: 'messages',
  messagesDone: 'messagesDone',
  callback: 'callback',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ICPMatchCompanyScalarFieldEnum = {
  id: 'id',
  organization_id: 'organization_id',
  icp_score: 'icp_score',
  icp_reason: 'icp_reason',
  name: 'name',
  domain: 'domain',
  company_description: 'company_description',
  entity: 'entity',
  entity_type: 'entity_type',
  siteId: 'siteId',
  campaignId: 'campaignId'
};

exports.Prisma.ICPMatchContactScalarFieldEnum = {
  id: 'id',
  email: 'email',
  name: 'name',
  first_name: 'first_name',
  last_name: 'last_name',
  title: 'title',
  company_domain: 'company_domain',
  email_verified: 'email_verified',
  email_message: 'email_message',
  linkedin: 'linkedin',
  role_relevance: 'role_relevance',
  role_reason: 'role_reason',
  company_name: 'company_name',
  summary: 'summary',
  siteId: 'siteId',
  campaignId: 'campaignId'
};

exports.Prisma.ICPMatchEmailScalarFieldEnum = {
  id: 'id',
  first_name: 'first_name',
  last_name: 'last_name',
  email: 'email',
  title: 'title',
  organization_id: 'organization_id',
  summary: 'summary',
  company_description: 'company_description',
  company_extra_description: 'company_extra_description',
  company_title: 'company_title',
  company_relevance: 'company_relevance',
  role_relevance: 'role_relevance',
  signature: 'signature',
  subject: 'subject',
  body: 'body',
  domain: 'domain',
  siteId: 'siteId',
  campaignId: 'campaignId'
};

exports.Prisma.AgenticQueryResultScalarFieldEnum = {
  id: 'id',
  icpStatistics: 'icpStatistics',
  filter: 'filter',
  filterDescription: 'filterDescription',
  query: 'query',
  type: 'type',
  minScore: 'minScore',
  modelName: 'modelName',
  method: 'method',
  bestExample: 'bestExample',
  worstExample: 'worstExample',
  results: 'results',
  siteId: 'siteId',
  campaignId: 'campaignId',
  created_date: 'created_date',
  updated_date: 'updated_date'
};

exports.Prisma.AgenticSystemControlScalarFieldEnum = {
  id: 'id',
  siteId: 'siteId',
  campaignId: 'campaignId',
  type: 'type',
  action: 'action',
  message: 'message'
};

exports.Prisma.EmailDomainStatsScalarFieldEnum = {
  id: 'id',
  headers: 'headers',
  message_id: 'message_id',
  subject: 'subject',
  from: 'from',
  sent_date: 'sent_date',
  received_date: 'received_date',
  smtp_ip: 'smtp_ip',
  is_spam: 'is_spam',
  inbox: 'inbox',
  scl_score: 'scl_score',
  emailDomainid: 'emailDomainid'
};

exports.Prisma.EmailIPScalarFieldEnum = {
  ip: 'ip',
  related_ips: 'related_ips',
  reputation: 'reputation',
  volume_info: 'volume_info',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  emailDomainid: 'emailDomainid'
};

exports.Prisma.MouseSessionScalarFieldEnum = {
  title: 'title',
  description: 'description',
  mx_record: 'mx_record',
  email: 'email',
  emailId: 'emailId',
  emailDomainid: 'emailDomainid',
  id: 'id',
  session_id: 'session_id',
  landing_page: 'landing_page',
  device_category: 'device_category',
  useragent: 'useragent',
  viewport_width: 'viewport_width',
  viewport_height: 'viewport_height',
  interactions_count: 'interactions_count',
  scroll_count: 'scroll_count',
  movement_count: 'movement_count',
  session_start_ts: 'session_start_ts',
  session_end_ts: 'session_end_ts',
  session_length_seconds: 'session_length_seconds',
  is_bot: 'is_bot',
  confidence: 'confidence',
  reasons: 'reasons',
  bot_score: 'bot_score',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BlacklistedDomainScalarFieldEnum = {
  id: 'id',
  domain: 'domain',
  blacklisted: 'blacklisted',
  listed: 'listed',
  emailDomainid: 'emailDomainid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.UserRole = exports.$Enums.UserRole = {
  MEMBER: 'MEMBER',
  ADMIN: 'ADMIN'
};

exports.SiteType = exports.$Enums.SiteType = {
  SHOPIFY: 'SHOPIFY',
  CUSTOM: 'CUSTOM',
  GTM: 'GTM',
  DEMO: 'DEMO'
};

exports.MailServer = exports.$Enums.MailServer = {
  MAILDOSO: 'MAILDOSO',
  MAILSCALE: 'MAILSCALE',
  PRIMEFORGE: 'PRIMEFORGE',
  MAILFORGE: 'MAILFORGE',
  SES: 'SES',
  AUTHSMTP: 'AUTHSMTP',
  SMTP2GO: 'SMTP2GO',
  INFRAMAIL: 'INFRAMAIL',
  CUSTOM: 'CUSTOM'
};

exports.MailboxStatus = exports.$Enums.MailboxStatus = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  REMOVED: 'REMOVED'
};

exports.CSVUploadStatus = exports.$Enums.CSVUploadStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

exports.AIUploadStatus = exports.$Enums.AIUploadStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

exports.AIEmailCampaignStatus = exports.$Enums.AIEmailCampaignStatus = {
  ACTIVE: 'ACTIVE',
  REMOVED: 'REMOVED',
  PAUSED: 'PAUSED'
};

exports.Day = exports.$Enums.Day = {
  Mon: 'Mon',
  Tue: 'Tue',
  Wed: 'Wed',
  Thu: 'Thu',
  Fri: 'Fri',
  Sat: 'Sat',
  Sun: 'Sun'
};

exports.AIStrategyStatus = exports.$Enums.AIStrategyStatus = {
  ACTIVE: 'ACTIVE',
  REMOVED: 'REMOVED',
  PAUSED: 'PAUSED'
};

exports.PaymentStatus = exports.$Enums.PaymentStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

exports.AIEmailStatus = exports.$Enums.AIEmailStatus = {
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  EDITED: 'EDITED',
  ACCEPTED: 'ACCEPTED',
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  BOUNCED: 'BOUNCED',
  COMPLAINT: 'COMPLAINT',
  OPENED: 'OPENED',
  CLICKED: 'CLICKED',
  UNSUBSCRIBED: 'UNSUBSCRIBED',
  QUEUED: 'QUEUED',
  QUEUED_BUCKET: 'QUEUED_BUCKET',
  CLICKED_MICROSOFT: 'CLICKED_MICROSOFT'
};

exports.SequenceStatus = exports.$Enums.SequenceStatus = {
  PENDING: 'PENDING',
  ONGOING: 'ONGOING',
  COMPLETED: 'COMPLETED',
  DISABLED: 'DISABLED',
  FAILED: 'FAILED'
};

exports.AILinkedInInviteStatus = exports.$Enums.AILinkedInInviteStatus = {
  PENDING: 'PENDING',
  QUEUED: 'QUEUED',
  SENT: 'SENT',
  ACCEPTED: 'ACCEPTED',
  MESSAGE_SENT: 'MESSAGE_SENT',
  MESSAGE_REPLIED: 'MESSAGE_REPLIED',
  REJECTED: 'REJECTED'
};

exports.Prisma.ModelName = {
  nodes: 'nodes',
  outbox: 'outbox',
  User: 'User',
  Site: 'Site',
  EmailDomain: 'EmailDomain',
  Mailbox: 'Mailbox',
  Invitation: 'Invitation',
  Account: 'Account',
  Session: 'Session',
  CSVUpload: 'CSVUpload',
  AIUpload: 'AIUpload',
  AIEmailCampaign: 'AIEmailCampaign',
  AIStrategy: 'AIStrategy',
  CompanyLeadExclusion: 'CompanyLeadExclusion',
  Payment: 'Payment',
  AIEmail: 'AIEmail',
  AIEmailAttachment: 'AIEmailAttachment',
  InboxEmail: 'InboxEmail',
  EmailBounce: 'EmailBounce',
  AILinkedInInvite: 'AILinkedInInvite',
  AILinkedInInviteStat: 'AILinkedInInviteStat',
  Email: 'Email',
  InviteAccount: 'InviteAccount',
  EmailStat: 'EmailStat',
  EmailUserSession: 'EmailUserSession',
  CrawledSite: 'CrawledSite',
  CrawledOrganization: 'CrawledOrganization',
  CrawledEmail: 'CrawledEmail',
  CrawledExternalEmail: 'CrawledExternalEmail',
  CrawledPhone: 'CrawledPhone',
  CrawledBingSession: 'CrawledBingSession',
  ICPMatchCompany: 'ICPMatchCompany',
  ICPMatchContact: 'ICPMatchContact',
  ICPMatchEmail: 'ICPMatchEmail',
  AgenticQueryResult: 'AgenticQueryResult',
  AgenticSystemControl: 'AgenticSystemControl',
  EmailDomainStats: 'EmailDomainStats',
  EmailIP: 'EmailIP',
  MouseSession: 'MouseSession',
  BlacklistedDomain: 'BlacklistedDomain'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
